<script setup lang="js">
import { onMounted, onUpdated, ref } from 'vue'

import { fetchIcon, svgToImgData } from '@/packages/icons'

const props = defineProps({
  name: {
    type: String,
    default: 'error',
  },
  pack: {
    type: String,
    default: 'linear',
    validators: value => ['linear', 'twotones', 'flags'].includes(value),
  },
  size: {
    type: [String, Number],
    default: 16,
  },
  thickness: {
    type: [String, Number],
    default: 1,
  },
  asImg: {
    type: Boolean,
    default: false,
  },
  packed: {
    type: Boolean,
    default: true,
  },
})

const el = ref(null)

const mountIcon = (el, data, attrs) => {
  if (el instanceof Image) {
    el.src = svgToImgData(data)

    attrs.width && (el.width = attrs.width ?? props.size ?? 24)

    attrs.height && (el.height = attrs.height ?? props.size ?? 24)
    return
  }

  if (!el) return
  el.innerHTML = data
  // Aplica atributos do ícone, mas remove width/height se não temos prop size
  Object.keys(attrs).forEach(a => {
    if (!props.size && (a === 'width' || a === 'height')) {
      return // Não aplica width/height para permitir controle via CSS
    }
    el.setAttribute(a, attrs[a])
  })

  // Apenas aplica atributos de tamanho se a prop size foi fornecida
  if (props.size) {
    el.setAttribute('width', props.size)
    el.setAttribute('height', props.size)
  }
  el.setAttribute('stroke-width', props.thickness)
}

const renderIcon = () => {
  if (el.value) {
    fetchIcon(props.pack, props.name).then(spec => {
      mountIcon(el.value, spec.n, spec.a)
    })
  }
}

onUpdated(() => {
  renderIcon()
})

onMounted(() => {
  renderIcon()
})
</script>

<template>
  <i role="img" :class="$attrs.class" v-if="packed">
    <svg v-if="!asImg" ref="el" xmlns="http://www.w3.org/2000/svg" />
    <img v-else ref="el" alt="" src="" />
  </i>
  <svg v-else-if="!asImg" ref="el" xmlns="http://www.w3.org/2000/svg" :class="$attrs.class" />
  <img v-else ref="el" alt="" src="" :class="$attrs.class" />
</template>

<style>
/* Definindo a animação de piscar */
@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.blink {
  animation: blink 3s infinite;
}
</style>
